( function( $ ) {

    /*input phone*/
    $('input[type="text"].js-phnInp').on('input', function() {
        this.value = this.value.replace(/[^0-9\+]/g, '');
    });
    /*input phone*/
 
    /*desktop/mob link change*/
    $(window).on('load resize', function(){
        $('[href^="tel:"]').each(function(){
            var $this = $(this);
            var tag = '';
            if ($(window).width() > 991) {
                // e.preventDefault();
                tag = '<span>';
            } else {
                tag = '<a>';
            }
            var $span = $(tag).html($this.html());
            $.each(this.attributes, function() {
                $span.attr(this.name, this.value);
            });
            $this.replaceWith($span);
        });
    });
    /*desktop/mob link change*/

    /*header*/
    $(window).scroll(function(){
        var hHeight = $('.js-header').outerHeight();
        if ($(window).scrollTop() > hHeight) {
            $('.js-header').addClass('fixed');
        } else {
            $('.js-header').removeClass('fixed');
        }
    });
    /*header*/

    /*header menu*/
    $('.js-hMenuBtn').click(function(){
        $(this).toggleClass('active');
        $('.js-hMenu').slideToggle();
    });


    $('.js-hMenu').click(function(e) {
        e.stopPropagation();
    });
    $('.js-hMenu ul li a').click(function(e) {
        if ($(window).width() < 992) {
            $('.js-hMenuBtn').removeClass('active');
            $('.js-hMenu').slideUp();
        }
    });

    $('.js-hMenuArr').click(function(e) {
        $(this).toggleClass('clicked');
        $(this).closest('.menu-item-has-children').toggleClass('opened')
        $(this).siblings('.sub-menu').slideToggle()
    });
    /*header menu*/

    /*modal contact*/
    $('.js-contBtn, a[href="#contact_modal"]').click(function(e){
        e.preventDefault();
        $('.js-modalContact').addClass('active');
        $('body').css('overflow', 'hidden');
    })
    $('.js-modalContactCls').click(function(){
        $('.js-modalContact').removeClass('active');
        $('body').css('overflow', '');
    });
    /*modal contact*/

    /*video*/
    $(document).ready(function () {
        if ($('#vimeo-player').length > 0) {
            var iframe = $('#vimeo-player')[0];
            var player = new Vimeo.Player(iframe);
            player.getVolume().then(function (volume) {
                player.setVolume(0);
            });

            function toggleSound(_this) {
                player.getVolume().then(function (volume) {
                    _this.find('.sound').removeClass('active');
                    if (volume > 0) {
                        player.setVolume(0);
                        _this.find('.sound[data-sound="disabled"]').addClass('active');
                    } else {
                        player.setVolume(1);
                        _this.find('.sound[data-sound="enabled"]').addClass('active');
                    }
                });
            }

            $('.js-firstLoud').on('click', function () {
                toggleSound($(this));
            });
        }
    });
    /*video*/

    /*main-vals*/
    $(document).ready(function () {
        if ($(window).width() > 991) {
            var sTm = null;
            $(document).on("mouseover", ".js-mainValsListCol", function () {
                if ($(window).width() >= 992) {
                    if (!$(this).hasClass("active") && !$(this).closest('.js-mainValsListCol').hasClass("active")) {
                        clearTimeout(sTm);
                        var minHeight = $('.js-mainValsListCol.active').height();
                        $('.js-mainValsListCol').closest('div').css('min-height', minHeight + 'px');
                        $('.js-mainValsListCol').removeClass("active");
                        $('.js-mainValsListColTxt').slideUp();
                        $(this).addClass("active");
                        $(this).find('.js-mainValsListColTxt').slideDown();
                        sTm = setTimeout(function(){
                            $('.js-mainValsListCol').closest('div').css('min-height', '');
                        }, 300);
                    }
                }
            });
        } else {
            $('.js-mainValsSlider').slick({
                arrows: true,
                dots: true,
                centerMode: false,
                slidesToShow: 2,
                prevArrow: '<button class="arrow prev-arrow"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.25 9H3.75" stroke="#3B3B3B" stroke-linecap="round"/> <path d="M9 14.25L3.75 9L9 3.75" stroke="#3B3B3B" stroke-linecap="round"/> </svg></button>',
                nextArrow: '<button class="arrow next-arrow"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.75 9H14.25" stroke="#3B3B3B" stroke-linecap="round"/> <path d="M9 14.25L14.25 9L9 3.75" stroke="#3B3B3B" stroke-linecap="round"/> </svg></button>',
                appendArrows: $('.js-mainValsSliderArrows'),
                appendDots: $('.js-mainValsSliderDots'),
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    });
    /*main-vals*/

    /*main gal*/
    $('.js-mainGalSlider').slick({
        arrows: true,
        dots: true,
        centerMode: false,
        slidesToShow: 1,
        prevArrow: '<button class="arrow prev-arrow"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.25 9H3.75" stroke="#3B3B3B" stroke-linecap="round"/> <path d="M9 14.25L3.75 9L9 3.75" stroke="#3B3B3B" stroke-linecap="round"/> </svg></button>',
        nextArrow: '<button class="arrow next-arrow"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.75 9H14.25" stroke="#3B3B3B" stroke-linecap="round"/> <path d="M9 14.25L14.25 9L9 3.75" stroke="#3B3B3B" stroke-linecap="round"/> </svg></button>',
        appendArrows: $('.js-mainGalSliderArrows'),
        appendDots: $('.js-mainGalSliderDots')
    });
    /*main gal*/

    /*main cons*/
    $('.js-mainConsSlider').slick({
        arrows: true,
        dots: false,
        centerMode: false,
        slidesToShow: 3,
        prevArrow: '<button class="arrow prev-arrow"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.25 9H3.75" stroke="#3B3B3B" stroke-linecap="round"/> <path d="M9 14.25L3.75 9L9 3.75" stroke="#3B3B3B" stroke-linecap="round"/> </svg></button>',
        nextArrow: '<button class="arrow next-arrow"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.75 9H14.25" stroke="#3B3B3B" stroke-linecap="round"/> <path d="M9 14.25L14.25 9L9 3.75" stroke="#3B3B3B" stroke-linecap="round"/> </svg></button>',
        appendArrows: $('.js-mainConsSliderArrows'),
        appendDots: $('.js-mainConsSliderDots'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    dots: true
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    dots: true
                }
            }
        ]
    });
    /*main cons*/

    /*simple parallax
    $(window).on('load resize', function(){
        var image = document.getElementsByClassName('js-parallax');
        new simpleParallax(image);
    });
    simple parallax*/
    /*rellax*/
    if ($('.js-parallax').length > 0) {
        const rellax = new Rellax('.js-parallax', {
            speed: -2,
            center: true
        });
    }
    /*rellax*/


    /*trait posts*/
    if ($('.js-traitPostsBl').length > 0) {
        $(document).on("mouseover", ".js-traitPostsBl", function () {
            if ($(window).width() >= 992) {
                if (!$(this).hasClass("active") && !$(this).closest('.js-traitPostsBl').hasClass("active")) {
                    $('.js-traitPostsBl').removeClass("active");
                    $('.js-traitPostsBlImg').removeClass("active");
                    $('.js-traitPostsBlData').slideUp();
                    $(this).addClass("active");
                    $(this).find('.js-traitPostsBlData').slideDown();
                    $('.js-traitPostsBlImg[data-img="' + $(this).data('img') + '"]').addClass("active");
                }
            }
        });
        $('.js-traitPostsBl').click(function () {
            if ($(window).width() < 992) {
                $('.js-traitPostsBl').removeClass("active");
                $('.js-traitPostsBlData').slideUp();
                $(this).find('.js-traitPostsBlData').slideDown();
                $(this).addClass("active");
            }
        });
    }
    /*trait posts*/



    /*scroll sidebar*/
    $(window).on('load resize', function(){
        if ($('.js-singleEquipeSide').length > 0) {
            if ($(window).width() > 991) {
                var singleSidebarTop = $('.js-singleEquipeSide').offset().top;
                var singleSidebarRailTop = $('.js-singleEquipeSideRail').offset().top;
                var headerOffset = $('header').outerHeight();
                var windowTop = $(window).scrollTop() + headerOffset + 30;

                var singleSidebarH = $('.js-singleEquipeSide').outerHeight();
                var singleSidebarMenuH = $('.js-singleEquipeSideMenu').outerHeight();
                if (singleSidebarH > singleSidebarMenuH) {
                    $('.js-singleEquipeSideRail').height(singleSidebarH - singleSidebarMenuH);
                }
                var singleSidebarRailH = $('.js-singleEquipeSideRail').outerHeight();
                var singleSidebarRailBottom = singleSidebarRailTop + singleSidebarRailH;

                $(window).scroll(function(){
                    windowTop = $(window).scrollTop() + headerOffset + 30;
                    if (windowTop > singleSidebarTop && windowTop < singleSidebarRailBottom) {
                        $('.js-singleEquipeSideMenu').css('top', windowTop - singleSidebarTop)
                    } else if (windowTop > singleSidebarTop && windowTop >= singleSidebarRailBottom) {
                        $('.js-singleEquipeSideMenu').css('top', '100%')
                    } else if (windowTop <= singleSidebarTop) {
                        $('.js-singleEquipeSideMenu').css('top', '0')
                    }
                })
            } else {
                $('.js-singleEquipeSideRail').css('height', 'auto')
            }
        }
    })
    /*scroll sidebar*/


    /*page faq*/
    $('.js-pageFaqCat').click(function(){
        var id = $(this).data('id');
        if (id === 'all') {
            $('.js-pageFaqListItem').slideDown();
        } else if ($('.js-pageFaqCat.active').data('id') === 'all') {
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').slideUp();
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').removeClass('opened');
        } else {
            $('.js-pageFaqListItem').slideUp();
            $('.js-pageFaqListItem').removeClass('opened');
            $('.js-pageFaqListItem[data-id="'+id+'"]').slideDown();
            $('.js-pageFaqListItem[data-id="'+id+'"]').addClass('opened');
        }
        $('.js-pageFaqCat').removeClass('active')
        $(this).addClass('active')


        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        $('.js-pageFaqListItem.opened .js-pageFaqListBurg').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgWrap').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgTxt').eq(0).slideDown()
    })
    $('.js-pageFaqListBurg').click(function(){
        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        $(this).addClass('active')
        $(this).closest('.js-pageFaqListBurgWrap').addClass('active')
        $(this).siblings('.js-pageFaqListBurgTxt').slideDown()
    })
    /*page faq*/

    /*page clin*/
    $('[data-beforeafter]').each(function () {
        $(this).beforeAfter({
            movable: true,
            clickMove: true,
            position: 50,
            opacity: 0.8,
            activeOpacity: 1,
            hoverOpacity: 1,
            separatorColor: '#ffffff',
            bulletColor: '#ffffff',
            arrowColor: '#3B3B3B',
            onMoveStart: function () {},
            onMoving: function () {},
            onMoveEnd: function () {}
        });
    });

    /*page clin*/

    /*page trouve gal*/
    $('.js-pageTrouveGalSlider').each(function(){
        $(this).slick({
            arrows: true,
            dots: true,
            centerMode: false,
            slidesToShow: 1,
            prevArrow: '<button class="arrow prev-arrow"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.25 9H3.75" stroke="#3B3B3B" stroke-linecap="round"/> <path d="M9 14.25L3.75 9L9 3.75" stroke="#3B3B3B" stroke-linecap="round"/> </svg></button>',
            nextArrow: '<button class="arrow next-arrow"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.75 9H14.25" stroke="#3B3B3B" stroke-linecap="round"/> <path d="M9 14.25L14.25 9L9 3.75" stroke="#3B3B3B" stroke-linecap="round"/> </svg></button>',
            appendArrows: $(this).closest('.js-pageTrouveGalSliderWrap').find('.js-pageTrouveGalSliderArrows'),
            appendDots: $(this).closest('.js-pageTrouveGalSliderWrap').find('.js-pageTrouveGalSliderDots')
        });
    });
    /*page trouve gal*/

    /*wpcf7 thankyou*/
    document.addEventListener('wpcf7mailsent', function (event) {
        $('.js-modalContact').addClass('active');
        $('body').css('overflow', 'hidden');
    }, false);
    $('.js-modalContactCls').click(function(){
        $('.js-modalContact').removeClass('active');
        $('body').css('overflow', '');
    });
    /*wpcf7 thankyou*/

    /*page cons slider*/
    $('.js-pageConsTerm').click(function(){
        if (!$(this).hasClass('active')) {
            var _this = $(this);
            $.ajax({
                url: ajax.ajaxurl,
                type: 'POST',
                data: {
                    'action': 'get_cons_posts',
                    'cat': _this.data('term')
                },
                success: function(response) {
                    $('.js-pageConsTerm').removeClass('active');
                    _this.addClass('active');
                    $('.js-pageConsPosts').html(response);
                },
                error: function(xhr, status, error) {
                    console.error(xhr.responseText);
                }
            });
        }
    })
    /*page cons slider*/

    /*page cas cliniq*/
    $('.js-pageClinTerm').click(function(){
        if (!$(this).hasClass('active')) {
            var _this = $(this);
            $.ajax({
                url: ajax.ajaxurl,
                type: 'POST',
                data: {
                    'action': 'get_clin_posts',
                    'cat': _this.data('term')
                },
                success: function(response) {
                    $('.js-pageClinTerm').removeClass('active');
                    _this.addClass('active');
                    $('.js-pageClinPosts').html(response);


                    $('[data-beforeafter]').each(function () {
                        $(this).beforeAfter({
                            movable: true,
                            clickMove: true,
                            position: 50,
                            opacity: 0.8,
                            activeOpacity: 1,
                            hoverOpacity: 1,
                            separatorColor: '#ffffff',
                            bulletColor: '#ffffff',
                            arrowColor: '#3B3B3B',
                            onMoveStart: function () {},
                            onMoving: function () {},
                            onMoveEnd: function () {}
                        });
                    });
                },
                error: function(xhr, status, error) {
                    console.error(xhr.responseText);
                }
            });
        }
    })
    /*page cas cliniq*/

    $('.js-widgToolsBl').mouseover(function() {
        $('.js-widgToolsList').removeClass('active');
        $('.js-widgToolsList[data-id="'+$(this).data('id')+'"]').addClass('active');
    });
    $('.js-widgTools').mouseleave(function(e) {
        $('.js-widgToolsList').removeClass('active');
    });

    /*main vals*/

    $('.js-pageConsVidsBl').click(function(){
        let vimeoId = $(this).data('video');
        var iframe = $('<iframe>', {
            src: 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&loop=0&autopause=0&muted=0',
            width: 1600,
            height: 900,
            frameborder: 0,
            allow: 'autoplay; fullscreen',
            allowfullscreen: true
        });
        $('.js-pageConsModalVid').append(iframe);
        $('.js-pageConsModal').addClass('active');
    })
    $('.js-pageConsModalCls').click(function(){
        $('.js-pageConsModal').removeClass('active');
        $('.js-pageConsModalVid').html('');
    });
    /*main vals*/

}( jQuery ) );
